import { c as _c } from "react/compiler-runtime";
// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useMutation } from '@tanstack/react-query';
import { axiosFetch } from '@cntxt/shared/infrastructure/api/http';
import type { EndpointData, EndpointParams } from '../api/batchEvaluate';
export async function network(data: Awaited<EndpointParams['params']>): Promise<EndpointData['data']> {
  const response = await axiosFetch<EndpointData['data']>({
    apiUrl: '/api/v1/featureFlags/batch',
    method: 'POST',
    body: data
  });
  return response;
}
export const useBatchEvaluateMutation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: network
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};